import styles from "./BackgroundDecoration.module.scss";

/**
 * BackgroundDecoration renders the decorative background pattern (rotated circles).
 * This component handles only visual decoration and has no layout concerns.
 * It is rendered once in RootLayout for non-embed routes.
 */
export function BackgroundDecoration() {
  return (
    <div className={styles.background}>
      <div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
